<form [formGroup]="supplyRequestForm">
    <dx-load-panel
        shadingColor="rgba(0,0,0,0.4)"
        [(visible)]="isLoading"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="true"
        [closeOnOutsideClick]="false">
    </dx-load-panel>
    <div id="supplyRequestForm" fxLayout="column" fxLayoutAlign="start center">
        <div class="content-block dx-card responsive-paddings ocl-top-container contact-block">
            <dx-toolbar id="navigation-header" style=" padding-right: 26px!important; height: 50px!important;">
                <dxi-item location="before">
                    <h3 class="content-block" style="padding-left: 24px !important;">Supply Request</h3>
                </dxi-item>
                <dxi-item location="after">
                    <dx-button [text]="'Send'" (click)="submit()"></dx-button>
                </dxi-item>
            </dx-toolbar>
        </div>
        <div class="content-block dx-card responsive-paddings ocl-bottom-container contact-block">
            <div fxLayout="column" fxLayoutAlign="space-between">
                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between">
                    <div fxLayout="column" fxLayoutAlign="start space-between" fxFlex="49" style="padding-top: 23px; padding-left: 16px"
                        [ngStyle.lt-md]="{'padding-right': '16px'}">
                        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">
                            <div fxLayout="column" class="dx-field" fxFlex="49">
                                <div class="dx-field-label">Last Name <span class="ocl-required-indicator">*</span></div>
                                <div class="dx-field-value">
                                    <dx-text-box formControlName="lastName" class="uppercase">
                                        <dx-validator validationGroup="supplyRequestForm">
                                            <dxi-validation-rule type="required" message="Last name is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div fxLayout="column" class="dx-field" fxFlex="49">
                                <div class="dx-field-label">First Name <span class="ocl-required-indicator">*</span></div>
                                <div class="dx-field-value">
                                    <dx-text-box formControlName="firstName" class="uppercase">
                                        <dx-validator validationGroup="supplyRequestForm">
                                            <dxi-validation-rule type="required" message="First name is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between">
                            <div fxLayout="column" class="dx-field" fxFlex="49">
                                <div class="dx-field-label">Email <span class="ocl-required-indicator">*</span></div>
                                <div class="dx-field-value">
                                    <dx-text-box formControlName="email">
                                        <dx-validator validationGroup="supplyRequestForm">
                                            <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                                            <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div fxLayout="column" class="dx-field" fxFlex="49">
                                <div class="dx-field-label">Phone</div>
                                <div class="dx-field-value">
                                    <dx-text-box formControlName="phone" mask="000-000-0000" maskInvalidMessage="Phone is invalid">
                                        <dx-validator validationGroup="supplyRequestForm">
                                            <dxi-validation-rule type="pattern" [pattern]="phonePattern" message="Phone is invalid"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                        </div>
                        <div fxLayout="row">
                            <app-client-selector *ngIf="role !== 'Physician' && role !== 'Patient'" id="clientSelector" [required]="true"
                                                 [validationGroup]="'supplyRequestForm'"
                                                 [control]="supplyRequestForm.get('client')" style="width: 100%"></app-client-selector>
                        </div>
                    </div>
                    <div fxFlex="49" style="height: 240px;" [ngStyle.xs]="{height: '360px'}">
                        <app-comments-control
                            [label]="'Message'"
                            [control]="supplyRequestForm.get('message')"
                            [valueChange]="supplyRequestForm.invalid"
                            [ngStyle.xs]="{height: '360px'}">
                        </app-comments-control>
                    </div>
                </div>
                <div>
                    <dx-data-grid id="gridContainer"
                        [dataSource]="supplyCategories"
                        [masterDetail]="{ enabled: true, template: 'detail' }"
                        height="60vh"
                        [keyExpr]="'id'"
                        [showBorders]="true"
                        [wordWrapEnabled]="true"
                        style="padding-left: 16px; padding-right: 16px">
                        <dxo-pager
                            [visible]="true"
                            [allowedPageSizes]="[10, 20, 50, 100]"
                            [showInfo]="true"
                            [showNavigationButtons]="true"
                            [showPageSizeSelector]="true"
                        ></dxo-pager>
                        <dxi-column caption="Name" dataField="name"></dxi-column>
                        <div *dxTemplate="let category of 'detail'">
                            <div class="dx-card">
                                <dx-toolbar height="40" style="padding-left: 16px; padding-right: 16px;">
                                    <dxi-item location="before">
                                        <h4 style="margin-bottom: 0; margin-top: 0">Supplies</h4>
                                    </dxi-item>
                                </dx-toolbar>
                                <dx-data-grid
                                    [dataSource]="category.data.supplies"
                                    [showBorders]="true"
                                    style="padding-left: 16px; padding-right: 16px"
                                    [keyExpr]="'id'"
                                    [columnAutoWidth]="true"
                                    [wordWrapEnabled]="true"
                                    [columnHidingEnabled]="isPhoneOrTablet">
                                    <dxo-pager
                                        [visible]="true"
                                        [allowedPageSizes]="[10, 20, 50, 100]"
                                        [showInfo]="true"
                                        [showNavigationButtons]="true"
                                        [showPageSizeSelector]="true"
                                    ></dxo-pager>
                                    <dxo-editing
                                        mode="cell"
                                        [allowUpdating]="true">
                                    </dxo-editing>
                                    <dxo-filter-row [showOperationChooser]="true" [visible]="true"></dxo-filter-row>
                                    <dxo-selection mode="simple" showCheckBoxesMode="none"></dxo-selection>
                                    <dxi-column caption="Code" dataField="code" [allowEditing]="false" [minWidth]="100" [hidingPriority]="isPhoneOrTablet ? 1 : undefined"></dxi-column>
                                    <dxi-column caption="Name" dataField="name" [allowEditing]="false" [minWidth]="150" [hidingPriority]="isPhoneOrTablet ? 4 : undefined"></dxi-column>
                                    <dxi-column caption="Quantity" dataField="quantity" dataType="number" [minWidth]="100" [showEditorAlways]="isPhoneOrTablet"
                                                [hidingPriority]="isPhoneOrTablet ? 3 : undefined"></dxi-column>
                                    <dxi-column caption="Config" dataField="configSelected" width="80" [showEditorAlways]="isPhoneOrTablet"
                                                [hidingPriority]="isPhoneOrTablet ? 2 : undefined">
                                        <dxo-lookup
                                            [dataSource]="getFilteredConfigs"
                                            valueExpr="name"
                                            displayExpr="name">
                                        </dxo-lookup>
                                    </dxi-column>
                                    <dxi-column caption="Comment" cellTemplate="commentTemplate" [allowEditing]="false" [hidingPriority]="isPhoneOrTablet ? 0 : undefined"></dxi-column>

                                    <div *dxTemplate="let supply of 'commentTemplate'">
                                        <div fxLayout="row" fxLayoutAlign="center center" [innerHTML]="supply.data.comments ? transformYourHtml(supply.data.comments) : ''"></div>
                                    </div>
                                </dx-data-grid>
                            </div>
                        </div>
                    </dx-data-grid>
                </div>
            </div>
        </div>
    </div>
</form>

